/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

import Queue from "./Queue";

/*
Fronta volani (obvykle nacitani dat z API). O jeden pozadavek si muze rict ve stejnou chvili vice komponent a je zbytecne se ptat APi vicekrat.
Proto API zavola prvni pozadavek a odpoved se preda vsem ostatnim.
*/
export default class WorkerQueue {
    private queue: Queue

    constructor() {
        this.queue = new Queue();
    }

    worker() {
        if (this.queue.getSize() === 0) return;

        const { provider, resolve, reject } = this.queue.onTop();
        const next = () => {
            this.queue.remove();
            this.worker();
        };

        provider()
            .then((res: any) => {
                resolve(res);
                next();
            })
            .catch((err: any) => {
                reject(err);
                next();
            });
    }

    async push<T = any>(provider: () => Promise<T>): Promise<T> {
        console.log('Worker queue - add');
        return new Promise(
            async (resolve, reject) => {

                // kazdy pozadavek se zaradi do fronty, ktera je prijmuti odpovedi zpracovana
                this.queue.add({ provider, resolve, reject });

                // prvni pozadavek spusti nacitani dat
                if (this.queue.getSize() === 1) {
                    console.log('Worker queue - start');
                    this.worker();
                }
            }
        );
    }

}
